<template>
  <div class="visitStores-container">
    <div class="storeList">
      <div class="storeItem" v-for="store of storeList" :key="store.storeId">
        <div class="store-info">
          <div class="info-left">
            <div class="store-img">
              <img :src="store.logoUrl" alt="">
            </div>
            <div class="store-detail">
              <div class="store-type-name">
                <img v-if="store.storeType === 'U'" class="store-type" src="@/assets/images/pt-yxdp.png" alt="">
                <img v-if="store.storeType === 'S'" class="store-type" src="@/assets/images/pt-zy.png" alt="">
                <span class="store-name">{{ store.storeName }}</span>
              </div>
              <div class="store-description">{{ store.detail }}</div>
            </div>
          </div>
          <div class="info-right">
            <span class="contact" @click="handleStorePhone(store.note)"><el-icon class="el-icon-phone-outline"></el-icon>联系商家</span>
            <span class="stroll" @click="handleStoreDetail(store.storeId)">进店逛逛<el-icon class="el-icon-arrow-right"></el-icon></span>
          </div>
        </div>
        <div class="good-list">
          <div class="goodItem" v-for="good of store.gbShopCommodities.slice(0, 4)" :key="good.commodityId" @click="handleGoodDetail(good)">
            <div class="img">
              <img :src="getCommodityImg(good)" alt="">
              <img v-if="Number(good.reserve) === 0" class="soldOut1" src="@/assets/images/pt-soldOut.png" alt="">
            </div>
            <div class="info">
              <div>
                <div class="storeCommodity">
                  <img class="UImg" v-if="good.storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                  <img class="SImg" v-if="good.storeType === 'S'" src="@/assets/images/pt-yxdp.png" alt="">
                  <div class="commodityName">{{ good.commodityName }}</div>
                </div>
                <div class="commodityTag">
                  <span class="tag" v-for="tag of good.tags" :key="tag.tagId">{{ tag.tagName }}</span>
                </div>
              </div>
              
              <div class="price">
                <span class="retail" v-if="good.pays[0].payType === 1">
                  <span class="symbol">¥</span>{{ getRetailPriceMin(good).retailPrice }}
                </span>
                <span class="retail" v-if="good.pays[0].payType === 2">
                  {{ getRetailPriceMin(good).retailPrice }}&nbsp;提货值
                </span>
                <span class="original" v-if="good.pays[0].payType === 1">
                  <span class="symbol">¥</span>{{ getRetailPriceMin(good).skuPrice }}</span>
                <span class="original" v-if="good.pays[0].payType === 2">
                  {{ getRetailPriceMin(good).skuPrice }}&nbsp;提货值
                </span>
                <span class="sold">已售{{ good.salesNumber }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noMore" v-show="storeList.length <= 0">
      暂无数据
    </div>
    <!-- 分页 -->
    <el-row v-if="pageData.total" style="margin-top:10px">
      <el-col :span="24" class="paginateWrap">
        <el-pagination
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-col>
    </el-row>
    <div class="store-type-change" @click="handleChangeStoreType">
      <div class="common type-zero" :class="storeType === '' ? 'active-type' : ''" data-type="">全部</div>
      <div class="common type-first" :class="storeType === 'S' ? 'active-type' : ''" data-type="S">自营店铺</div>
      <div class="common type-second" :class="storeType === 'U' ? 'active-type' : ''" data-type="U">优选店铺</div>
      <div class="common type-third" :class="storeType === 'P' ? 'active-type' : ''" data-type="P">普通店铺</div>
    </div>
    <Cellphone :phone="cellStore" ref="cellphoneRef" />
  </div>
</template>

<script>
import Cellphone from '@/views/equityMall/pt/components/cellStore.vue'

import { mapMutations, mapState } from 'vuex'

export default {
  components: {
    Cellphone
  },
  data() {
    return {
      cellStore: null,
      // 分页相关
      pageData: {
        total: null,
        pageSizes: [8, 16, 32, 64],
        pageSize: 8,
        currentPage: 1
      },
      storeName: null,
      isNetWrong: false,
      storeList: [],
      storeType: '', // ''-全部 P-普通店铺 U-优选店铺 S-自营店铺 
    }
  },
  computed: {
    ...mapState('pt', ['currentStoreType'])
  },
  created() {
    this.$emit('resetStatus')
  },
  mounted() {
    this.$nextTick(() => {
      if (this.currentStoreType || this.currentStoreType === '') {
        this.storeType = this.currentStoreType
      } else {
        this.storeType = ''
      }
      this.queryAllStore()
    })
  },
  methods: {

    ...mapMutations('pt', ['setCurrentStoreType']),

    handleChangeStoreType(e) {
      this.storeType = e.target.dataset.type
      this.setCurrentStoreType(e.target.dataset.type)
      this.queryAllStore()
    },

    // 联系商家
    handleStorePhone(phone) {
      this.cellStore = phone
      this.$refs.cellphoneRef.showDialog()
    },

    // 跳转店铺详情页
    handleStoreDetail(storeId) {
      this.$router.push({
        name: 'ptOrdinaryStoreDetail',
        query: {
          storeId: storeId
        }
      })
    },

    // 跳转商品详情页
    handleGoodDetail(good) {
      this.$router.push({
        name: 'ptOrdinaryGoodDetail',
        query: {
          commodityId: good.commodityId,
          storeId: good.storeId,
        }
      })
    },

    // 提取商品主图
    getCommodityImg(commodity) {
      return commodity.imgs.find(img => Number(img.isMain) === 1).img
    },
    // 提取零售价(所有规格的最低价格)
    getRetailPriceMin(commodity) {
      let minObj = commodity.skus[0]
      commodity.skus.forEach(sku => {
        if (Number(sku.retailPrice) < Number(minObj.retailPrice) && Number(sku.display) === 1) {
          minObj = sku
        }
      })
      return minObj
    },

    // 查询所有店铺
    queryAllStore() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryStore))
      apiObj.param = {
        sort: [{direction: "DESC", property: "sortId"}],
        page: this.pageData.currentPage - 1,
        size: this.pageData.pageSize,
        storeName: this.storeName,
        storeType: this.storeType
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          this.pageData.total = value.totalElements
          this.isNetWrong = false
          this.storeList = value.content
        } else {
          this.$message({ message: message })
          this.isNetWrong = true
          this.storeList = []
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.queryAllStore()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.queryAllStore()
    },
  }
}
</script>

<style scoped lang="scss">
  .visitStores-container {
    margin: 21px auto 20px;
    width: 1200px;
    position: relative;
    .storeList {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;
      .storeItem {
        width: 100%;
        height: 536px;
        background: #ffffff;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        padding: 26px 20px 42px;
        box-sizing: border-box;
        overflow: hidden;
        gap: 20px;
        .store-info {
          display: flex;
          justify-content: space-between;
          .info-left {
            display: flex;
            gap: 10px;
            .store-img {
              width: 68px;
              height: 68px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .store-detail {
              display: flex;
              flex-direction: column;
              gap: 3px;
              .store-type-name {
                display: flex;
                align-items: center;
                gap: 10px;
                .store-type {
                  height: 16px;
                }
                .store-name {
                  font-size: 16px;
                  color: #333333;
                }
              }
              .store-description {
                color: #999999;
                font-size: 14px;
                width: 300px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
          .info-right {
            font-size: 16px;
            margin-top: 5px;
            .contact {
              cursor: pointer;
              color: #999999;
              margin-right: 14px;
              /deep/ .el-icon-phone-outline {
                color: #999999;
                margin-right: 3px;
              }
            }
            .stroll {
              cursor: pointer;
              color: #1571DB;
              /deep/ .el-icon-arrow-right {
                color: #1571DB;
                margin-left: 3px;
              }
            }
          }
        }
        .good-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          .goodItem {
            cursor: pointer;
            width: 284px;
            height: 380px;
            background: #FFFFFF;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .img {
              width: 100%;
              height: 282px;
              background: #E4E4E4;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .soldOut1 {
                position: absolute;
                top: 0;
                left: 0;
                transform: scale(0.7);
              }
            }
            .info {
              flex: 1;
              padding: 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .storeCommodity {
                display: flex;
                align-items: center;
                gap: 6px;
                img {
                  height: 16px;
                }
                .commodityName {
                  font-size: 14px;
                  color: #333333;
                  flex: 1;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .commodityTag {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
                margin-top: 7px;
                .tag {
                  color: #ED732E;
                  font-size: 10px;
                  border: 1px solid #ED732E;
                  padding: 0 2px;
                }
              }
              .price {
                font-size: 14px;
                .retail {
                  color: #333333;
                  .symbol {
                    color: #333333;
                    font-size: 10px;
                  }
                }
                .original {
                  text-decoration: line-through;
                  color: #cccccc;
                  font-size: 10px;
                  .symbol {
                    color: #cccccc;
                    font-size: 10px;
                  }
                }
                .sold {
                  font-size: 12px;
                  color: #999999;
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }
    }
    .noMore {
      color: #333333;
      font-size: 18px;
      font-weight: 500;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    // 分页样式
    /deep/ .el-pagination {
      .el-input {
        .el-input__inner {
          background: #ffffff;
        }
      }
    }
    .store-type-change {
      width: 150px;
      background: #ffffff;
      position: fixed;
      top: 400px;
      left: 207px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .common {
        user-select: none;
        cursor: pointer;
        color: #333333;
        font-size: 18px;
        flex: 1;
        text-align: center;
        line-height: 64px;
        &.active-type {
          color: #ffffff;
          background: #1571DB;
        }
      }
    }
  }
</style>